export const HOME_PAGE_YEAR = new Date().getFullYear();
